export const PERIOD_STEP = 1;
export const STEP = 10;
